











//
// WARNING
// This file is auto-generated by Commands.tst
// Don't try to edit it, your changes will be lost.
// If you nedd to change this file, edit Commands.tst.
//

import { Command } from "@signature/crs-client";
import { endpoint, CommandResult } from '@/modules/crs/crs';


    

    @Command('Automelec.Model-Automelec.Model.Commands.Dashboard.DeleteDashboardCommand')
    
    export class DeleteDashboardCommand {
        constructor( dashboardId: number ) {
            
                this.dashboardId = dashboardId;
            
        }

        
            public dashboardId: number;
        
    }

    export interface IDeleteDashboardCommand {
        
            dashboardId: number;
        
    }

    export async function deleteDashboard( command: DeleteDashboardCommand ): Promise<CommandResult<void>>
    export async function deleteDashboard( { dashboardId }: IDeleteDashboardCommand ): Promise<CommandResult<void>>
    export async function deleteDashboard( model: any ): Promise<CommandResult<void>> {
        if(model == null) throw new Error("Command cannot be null.");

        var result: CommandResult<void>;

        if(model instanceof DeleteDashboardCommand) {
            result = await endpoint.send<CommandResult<void>>(model);
        }
        else {
            result = await endpoint.send<CommandResult<void>>( new DeleteDashboardCommand( model['dashboardId'] ) );
        }

        return result;
    }

    /**
    * Extraneous types
    */
    export namespace DeleteDashboardCommand.ExtraneousTypes {
        

        
    }

